// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/taskhead-icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/bar-icon.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upcoming-widget {
  padding: 1rem;
  padding-top: 0rem;
  background: #ffffff;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.upcoming-widget .tabs-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 0.5rem;
  flex-shrink: 0;
}
.upcoming-widget .tabs {
  display: flex;
  gap: 6px;
  background: #f8fafc;
  border-radius: 8px;
  padding: 6px;
  flex-shrink: 0;
}
.upcoming-widget .tabs button {
  background: none;
  border: none;
  font-size: 0.95rem;
  padding: 8px 10px;
  cursor: pointer;
  position: relative;
  color: #64748b;
  font-weight: 500;
  transition: all 0.2s ease;
  flex: 1 1;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  white-space: nowrap;
}
.upcoming-widget .tabs button .tab-count {
  background: rgba(100, 116, 139, 0.1);
  color: #64748b;
  font-size: 0.75rem;
  padding: 0.125rem 0.375rem;
  border-radius: 10px;
  font-weight: 600;
  min-width: 18px;
  text-align: center;
}
.upcoming-widget .tabs button.active {
  border-bottom: 3px solid var(--primary-color);
  background: #F0F4FE;
}
.upcoming-widget .tabs button.active .tab-count {
  background: #fff;
  color: #6b7280;
}
.upcoming-widget .tabs button:hover:not(.active) {
  color: #374151;
  background: rgba(255, 255, 255, 0.5);
}
.upcoming-widget .hearing-sub-tabs {
  display: flex;
  gap: 4px;
  background: #f1f5f9;
  border-radius: 6px;
  padding: 4px;
  flex-shrink: 0;
}
.upcoming-widget .hearing-sub-tabs button {
  background: none;
  border: none;
  font-size: 0.8rem;
  padding: 6px 12px;
  cursor: pointer;
  position: relative;
  color: #64748b;
  font-weight: 500;
  border-radius: 4px;
  transition: all 0.2s ease;
  flex-shrink: 0;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;
  white-space: nowrap;
}
.upcoming-widget .hearing-sub-tabs button .tab-count {
  background: rgba(100, 116, 139, 0.1);
  color: #64748b;
  font-size: 0.7rem;
  padding: 0.125rem 0.375rem;
  border-radius: 8px;
  font-weight: 600;
  min-width: 16px;
  text-align: center;
}
.upcoming-widget .hearing-sub-tabs button.active {
  background: #D1FAE5;
  color: #065f46;
  font-weight: 600;
}
.upcoming-widget .hearing-sub-tabs button.active .tab-count {
  background: rgba(6, 95, 70, 0.15);
  color: #065f46;
}
.upcoming-widget .hearing-sub-tabs button:hover:not(.active) {
  color: #374151;
  background: rgba(255, 255, 255, 0.7);
}
.upcoming-widget .upcoming-content-wrapper {
  flex-grow: 1;
  position: relative;
  overflow: visible;
  padding-bottom: 3rem;
}
.upcoming-widget .upcoming-content-wrapper .upcoming-content-area {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  overflow: visible;
  min-height: fit-content;
}
.upcoming-widget .upcoming-content-wrapper .date-section {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  overflow: visible;
  transition: border-color 0.2s ease;
}
.upcoming-widget .upcoming-content-wrapper .date-section:hover {
  border-color: #d1d5db;
}
.upcoming-widget .upcoming-content-wrapper .date-header {
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  background: #f9fafb;
  padding: 1rem 1.25rem;
  margin: 0;
  border-bottom: 1px solid #e5e7eb;
  text-transform: uppercase;
  letter-spacing: 0.025em;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.upcoming-widget .upcoming-content-wrapper .date-header .item-count {
  font-size: 0.75rem;
  color: #6b7280;
  background: #e5e7eb;
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
  font-weight: 500;
  text-transform: none;
  letter-spacing: normal;
}
.upcoming-widget .upcoming-content-wrapper .items-grid {
  display: flex;
  flex-direction: column;
  gap: 0;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card {
  display: flex;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #f1f5f9;
  transition: all 0.2s ease;
  cursor: pointer;
  position: relative;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card:last-child {
  border-bottom: none;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card:hover {
  background: #f9fafb;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card:hover::before {
  opacity: 1;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: #6b7280;
  opacity: 0;
  transition: opacity 0.2s ease;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card .card-emoji {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  flex-shrink: 0;
  font-size: 1.25rem;
  position: relative;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card .card-emoji .court-type-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  font-size: 9px;
  font-weight: bold;
  padding: 2px 5px;
  border-radius: 10px;
  line-height: 1;
  z-index: 2;
  border: 1px solid rgba(255, 255, 255, 0.8);
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card .card-emoji .court-type-badge.high-court {
  background: linear-gradient(135deg, #1e40af, #3b82f6);
  color: #ffffff;
  box-shadow: 0 2px 4px rgba(30, 64, 175, 0.3);
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card .card-emoji .court-type-badge.district-court {
  background: linear-gradient(135deg, #7c3aed, #a855f7);
  color: #ffffff;
  box-shadow: 0 2px 4px rgba(124, 58, 237, 0.3);
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card .card-emoji .court-type-badge.supreme-court {
  background: linear-gradient(135deg, #b45309, #f59e0b);
  color: #ffffff;
  box-shadow: 0 2px 4px rgba(180, 83, 9, 0.3);
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card .card-details {
  flex-grow: 1;
  min-width: 0;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card .card-details .card-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 900;
  color: #6b7280;
  font-size: 0.8rem;
  margin-bottom: 8px;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card .card-details .card-title .courtref-displayboard {
  font-size: 12px;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card .card-details .card-title .status-chip {
  margin-left: auto;
  font-size: 0.7rem;
  padding: 0.25rem 0.5rem;
  border-radius: 8px;
  font-weight: 600;
  display: flex;
  gap: 4px;
  align-items: center;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card .card-details .card-title .status-chip.completed {
  background: #d1fae5;
  color: #065f46;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card .card-details .card-title .status-chip.pending {
  background: #fee2e2;
  color: #991b1b;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card .card-details .card-title .hearing-parties {
  font-size: 0.8rem;
  color: #6b7280;
  font-weight: 900;
  margin-left: 6px;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card .card-details .card-sub {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 0.8rem;
  color: #6b7280;
  font-weight: 500;
  white-space: normal;
  overflow-wrap: break-word;
  word-break: break-word;
  overflow: hidden;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card .card-details .card-sub .icon-image {
  flex-shrink: 0;
  margin-top: 2px;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card .card-details .card-sub::before {
  flex-shrink: 0;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card.upcoming-task-card .card-emoji {
  background: #f3f4f6;
  color: #6b7280;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card.upcoming-task-card .card-emoji::before {
  content: "";
  display: inline-block;
  width: 22px;
  height: 22px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card.hearing-card .card-emoji {
  background: #f3f4f6;
  color: #6b7280;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card.hearing-card .card-emoji::before {
  content: "";
  display: inline-block;
  width: 22px;
  height: 22px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: contain;
  background-repeat: no-repeat;
}
.upcoming-widget .upcoming-content-wrapper .no-data {
  text-align: center;
  color: #6b7280;
  padding: 3rem 2rem;
  font-size: 0.95rem;
  background: #f9fafb;
  border: 2px dashed #d1d5db;
  border-radius: 8px;
  margin-top: 1rem;
}
.upcoming-widget .upcoming-content-wrapper .show-more-toggle-container {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(to top, rgba(255, 255, 255, 0.95) 60%, transparent);
  cursor: pointer;
  z-index: 10;
  gap: 0.5rem;
}
.upcoming-widget .upcoming-content-wrapper .show-more-toggle-container .toggle-text {
  font-size: 0.875rem;
  color: #374151;
  font-weight: 500;
}
.upcoming-widget .upcoming-content-wrapper .show-more-toggle-container .toggle-circle {
  width: 32px;
  height: 32px;
  background: #374151;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  border: 2px solid #ffffff;
}
.upcoming-widget .upcoming-content-wrapper .show-more-toggle-container .toggle-circle .arrow-icon {
  color: #ffffff;
  font-size: 1rem;
  transition: transform 0.3s ease;
}
.upcoming-widget .upcoming-content-wrapper .show-more-toggle-container:hover .toggle-circle {
  background: #4b5563;
}
.upcoming-widget .upcoming-content-wrapper .show-more-toggle-container:hover .toggle-text {
  color: #111827;
}
.upcoming-widget .upcoming-content-wrapper .show-more-toggle-container.expanded .arrow-icon {
  transform: rotate(180deg);
}
@media (max-width: 1200px) {
  .upcoming-widget .tabs-container {
    flex-wrap: wrap;
    gap: 0.5rem;
  }
  .upcoming-widget .tabs-container .tabs {
    width: 100%;
  }
  .upcoming-widget .tabs-container .hearing-sub-tabs {
    width: 100%;
  }
}
@media (max-width: 768px) {
  .upcoming-widget {
    padding: 1.5rem;
  }
  .upcoming-widget .tabs-container {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
    margin-bottom: 1rem;
  }
  .upcoming-widget .tabs {
    width: 100%;
  }
  .upcoming-widget .tabs button {
    font-size: 0.9rem;
    padding: 0.65rem 1rem;
  }
  .upcoming-widget .hearing-sub-tabs {
    width: 100%;
    overflow-x: auto;
  }
  .upcoming-widget .hearing-sub-tabs::-webkit-scrollbar {
    height: 4px;
  }
  .upcoming-widget .hearing-sub-tabs::-webkit-scrollbar-track {
    background: transparent;
  }
  .upcoming-widget .hearing-sub-tabs::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 2px;
  }
  .upcoming-widget .hearing-sub-tabs button {
    font-size: 0.75rem;
    padding: 0.4rem 0.6rem;
    gap: 0.25rem;
  }
  .upcoming-widget .hearing-sub-tabs button .tab-count {
    font-size: 0.65rem;
    padding: 0.1rem 0.25rem;
    min-width: 14px;
  }
  .upcoming-widget .items-grid .upcoming-item-card {
    padding: 0.875rem 1rem;
  }
  .upcoming-widget .items-grid .upcoming-item-card .card-emoji {
    width: 36px;
    height: 36px;
    margin-right: 0.875rem;
    font-size: 1.1rem;
  }
  .upcoming-widget .items-grid .upcoming-item-card .card-emoji .court-type-badge {
    font-size: 8px;
    padding: 1px 4px;
    top: -3px;
    right: -3px;
  }
  .upcoming-widget .items-grid .upcoming-item-card .card-details .card-title {
    font-size: 0.9rem;
  }
  .upcoming-widget .items-grid .upcoming-item-card .card-details .card-sub {
    font-size: 0.75rem;
  }
}

.ref-with-tooltip {
  position: relative;
  cursor: pointer;
}
.ref-with-tooltip .custom-tooltip {
  position: absolute;
  top: 50%;
  left: 17%;
  transform: translateY(-50%) translateX(8px);
  background: #f5faff;
  color: #1e293b;
  border: 1px solid #dbeafe;
  box-shadow: 0 4px 16px rgba(147, 197, 253, 0.25);
  padding: 0.5rem 0.75rem;
  border-radius: 8px;
  font-size: 0.75rem;
  white-space: normal;
  max-width: 300px;
  z-index: 9999;
  opacity: 0;
  transition: opacity 0.3s ease, transform 0.3s ease;
  pointer-events: none;
}
.ref-with-tooltip:hover .custom-tooltip {
  opacity: 1;
  transform: translateY(-50%) translateX(0);
  pointer-events: auto;
}

.custom-tooltip {
  position: absolute;
  transform: translateX(-50%) translateY(-30%);
  background-color: #333;
  color: #fff;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 13px;
  max-width: 400px;
  word-wrap: break-word;
  z-index: 1000;
  pointer-events: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  line-height: 1.4;
  top: 250px;
  left: 200px;
}
.custom-tooltip::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #333;
}

.custom-next-date {
  color: #059669 !important;
  font-weight: 500 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/UpcomingListWidget/UpcomingListWidget.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AACF;AAEE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,qBAAA;EACA,cAAA;AAAJ;AAGE;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;AADJ;AAGI;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;AADN;AAGM;EACE,oCAAA;EACA,cAAA;EACA,kBAAA;EACA,0BAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AADR;AAIM;EACE,6CAAA;EACA,mBAAA;AAFR;AAIQ;EACE,gBAAA;EACA,cAAA;AAFV;AAMM;EACE,cAAA;EACA,oCAAA;AAJR;AAUE;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;AARJ;AAUI;EACE,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;AARN;AAUM;EACE,oCAAA;EACA,cAAA;EACA,iBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AARR;AAWM;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;AATR;AAWQ;EACE,iCAAA;EACA,cAAA;AATV;AAaM;EACE,cAAA;EACA,oCAAA;AAXR;AAgBE;EACE,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;AAdJ;AAgBI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;EACA,uBAAA;AAdN;AAiBI;EACE,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,kCAAA;AAfN;AAiBM;EACE,qBAAA;AAfR;AAmBI;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,qBAAA;EACA,SAAA;EACA,gCAAA;EACA,yBAAA;EACA,uBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAjBN;AAmBM;EACE,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;AAjBR;AAqBI;EACE,aAAA;EACA,sBAAA;EACA,MAAA;AAnBN;AAqBM;EACE,aAAA;EACA,qBAAA;EACA,gCAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;AAnBR;AAqBQ;EACE,mBAAA;AAnBV;AAsBQ;EACE,mBAAA;AApBV;AAsBU;EACE,UAAA;AApBZ;AAwBQ;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,UAAA;EACA,6BAAA;AAtBV;AAyBQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;AAvBV;AAyBU;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;EACA,0CAAA;AAvBZ;AAyBY;EACE,qDAAA;EACA,cAAA;EACA,4CAAA;AAvBd;AA0BY;EACE,qDAAA;EACA,cAAA;EACA,6CAAA;AAxBd;AA2BY;EACE,qDAAA;EACA,cAAA;EACA,2CAAA;AAzBd;AA8BQ;EACE,YAAA;EACA,YAAA;AA5BV;AA8BU;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AA5BZ;AA8BY;EACE,eAAA;AA5Bd;AA+BY;EACE,iBAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,QAAA;EACA,mBAAA;AA7Bd;AA+Bc;EACE,mBAAA;EACA,cAAA;AA7BhB;AAgCc;EACE,mBAAA;EACA,cAAA;AA9BhB;AAkCY;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAhCd;AAoCU;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;AAlCZ;AAoCY;EACE,cAAA;EACA,eAAA;AAlCd;AAqCY;EACE,cAAA;AAnCd;AAyCU;EACE,mBAAA;EACA,cAAA;AAvCZ;AAyCY;EACE,WAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;AAvCd;AA6CU;EACE,mBAAA;EACA,cAAA;AA3CZ;AA6CY;EACE,WAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;AA3Cd;AAkDI;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;AAhDN;AAmDI;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,+EAAA;EACA,eAAA;EACA,WAAA;EACA,WAAA;AAjDN;AAmDM;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;AAjDR;AAoDM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,yBAAA;AAlDR;AAoDQ;EACE,cAAA;EACA,eAAA;EACA,+BAAA;AAlDV;AAuDQ;EACE,mBAAA;AArDV;AAwDQ;EACE,cAAA;AAtDV;AA0DM;EACE,yBAAA;AAxDR;AA8DE;EACE;IACE,eAAA;IACA,WAAA;EA5DJ;EA8DI;IACE,WAAA;EA5DN;EA+DI;IACE,WAAA;EA7DN;AACF;AAiEE;EAhcF;IAicI,eAAA;EA9DF;EAgEE;IACE,sBAAA;IACA,oBAAA;IACA,YAAA;IACA,mBAAA;EA9DJ;EAiEE;IACE,WAAA;EA/DJ;EAiEI;IACE,iBAAA;IACA,qBAAA;EA/DN;EAmEE;IACE,WAAA;IACA,gBAAA;EAjEJ;EAmEI;IACE,WAAA;EAjEN;EAoEI;IACE,uBAAA;EAlEN;EAqEI;IACE,mBAAA;IACA,kBAAA;EAnEN;EAsEI;IACE,kBAAA;IACA,sBAAA;IACA,YAAA;EApEN;EAsEM;IACE,kBAAA;IACA,uBAAA;IACA,eAAA;EApER;EAyEE;IACE,sBAAA;EAvEJ;EAyEI;IACE,WAAA;IACA,YAAA;IACA,sBAAA;IACA,iBAAA;EAvEN;EAyEM;IACE,cAAA;IACA,gBAAA;IACA,SAAA;IACA,WAAA;EAvER;EA4EM;IACE,iBAAA;EA1ER;EA6EM;IACE,kBAAA;EA3ER;AACF;;AAiFA;EACE,kBAAA;EACA,eAAA;AA9EF;AAgFE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,2CAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,gDAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,UAAA;EACA,kDAAA;EACA,oBAAA;AA9EJ;AAiFE;EACE,UAAA;EACA,yCAAA;EACA,oBAAA;AA/EJ;;AAmFA;EACE,kBAAA;EACA,4CAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,aAAA;EACA,oBAAA;EACA,yCAAA;EACA,gBAAA;EACA,UAAA;EACA,WAAA;AAhFF;AAkFE;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,6BAAA;AAhFJ;;AAqFA;EACE,yBAAA;EACA,2BAAA;AAlFF","sourcesContent":[".upcoming-widget {\r\n  padding: 1rem;\r\n  padding-top: 0rem;\r\n  background: #ffffff;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n  // New container for tabs and sub-tabs\r\n  .tabs-container {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap: 1rem;\r\n    margin-bottom: 0.5rem;\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  .tabs {\r\n    display: flex;\r\n    gap: 6px;\r\n    background: #f8fafc;\r\n    border-radius: 8px;\r\n    padding: 6px;\r\n    flex-shrink: 0;\r\n\r\n    button {\r\n      background: none;\r\n      border: none;\r\n      font-size: 0.95rem;\r\n      padding: 8px 10px;\r\n      cursor: pointer;\r\n      position: relative;\r\n      color: #64748b;\r\n      font-weight: 500;\r\n      transition: all 0.2s ease;\r\n      flex: 1;\r\n      text-align: center;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      gap: 0.5rem;\r\n      white-space: nowrap;\r\n\r\n      .tab-count {\r\n        background: rgba(100, 116, 139, 0.1);\r\n        color: #64748b;\r\n        font-size: 0.75rem;\r\n        padding: 0.125rem 0.375rem;\r\n        border-radius: 10px;\r\n        font-weight: 600;\r\n        min-width: 18px;\r\n        text-align: center;\r\n      }\r\n\r\n      &.active {\r\n        border-bottom: 3px solid var(--primary-color);\r\n        background: #F0F4FE;\r\n\r\n        .tab-count {\r\n          background: #fff;\r\n          color: #6b7280;\r\n        }\r\n      }\r\n\r\n      &:hover:not(.active) {\r\n        color: #374151;\r\n        background: rgba(255, 255, 255, 0.5);\r\n      }\r\n    }\r\n  }\r\n\r\n  // Hearing sub-tabs styles - updated for inline layout\r\n  .hearing-sub-tabs {\r\n    display: flex;\r\n    gap: 4px;\r\n    background: #f1f5f9;\r\n    border-radius: 6px;\r\n    padding: 4px;\r\n    flex-shrink: 0;\r\n    \r\n    button {\r\n      background: none;\r\n      border: none;\r\n      font-size: 0.8rem;\r\n      padding: 6px 12px;\r\n      cursor: pointer;\r\n      position: relative;\r\n      color: #64748b;\r\n      font-weight: 500;\r\n      border-radius: 4px;\r\n      transition: all 0.2s ease;\r\n      flex-shrink: 0;\r\n      text-align: center;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      gap: 0.375rem;\r\n      white-space: nowrap;\r\n\r\n      .tab-count {\r\n        background: rgba(100, 116, 139, 0.1);\r\n        color: #64748b;\r\n        font-size: 0.7rem;\r\n        padding: 0.125rem 0.375rem;\r\n        border-radius: 8px;\r\n        font-weight: 600;\r\n        min-width: 16px;\r\n        text-align: center;\r\n      }\r\n\r\n      &.active {\r\n        background: #D1FAE5;\r\n        color: #065f46;\r\n        font-weight: 600;\r\n\r\n        .tab-count {\r\n          background: rgba(6, 95, 70, 0.15);\r\n          color: #065f46;\r\n        }\r\n      }\r\n\r\n      &:hover:not(.active) {\r\n        color: #374151;\r\n        background: rgba(255, 255, 255, 0.7);\r\n      }\r\n    }\r\n  }\r\n\r\n  .upcoming-content-wrapper {\r\n    flex-grow: 1;\r\n    position: relative;\r\n    overflow: visible;\r\n    padding-bottom: 3rem;\r\n\r\n    .upcoming-content-area {\r\n      display: flex;\r\n      flex-direction: column;\r\n      gap: 1rem;\r\n      overflow: visible;\r\n      min-height: fit-content;\r\n    }\r\n\r\n    .date-section {\r\n      background: #ffffff;\r\n      border: 1px solid #e5e7eb;\r\n      overflow: visible;\r\n      transition: border-color 0.2s ease;\r\n\r\n      &:hover {\r\n        border-color: #d1d5db;\r\n      }\r\n    }\r\n\r\n    .date-header {\r\n      font-size: 0.875rem;\r\n      font-weight: 600;\r\n      color: #374151;\r\n      background: #f9fafb;\r\n      padding: 1rem 1.25rem;\r\n      margin: 0;\r\n      border-bottom: 1px solid #e5e7eb;\r\n      text-transform: uppercase;\r\n      letter-spacing: 0.025em;\r\n      display: flex;\r\n      justify-content: space-between;\r\n      align-items: center;\r\n\r\n      .item-count {\r\n        font-size: 0.75rem;\r\n        color: #6b7280;\r\n        background: #e5e7eb;\r\n        padding: 0.25rem 0.5rem;\r\n        border-radius: 12px;\r\n        font-weight: 500;\r\n        text-transform: none;\r\n        letter-spacing: normal;\r\n      }\r\n    }\r\n\r\n    .items-grid {\r\n      display: flex;\r\n      flex-direction: column;\r\n      gap: 0;\r\n\r\n      .upcoming-item-card {\r\n        display: flex;\r\n        padding: 1rem 1.25rem;\r\n        border-bottom: 1px solid #f1f5f9;\r\n        transition: all 0.2s ease;\r\n        cursor: pointer;\r\n        position: relative;\r\n\r\n        &:last-child {\r\n          border-bottom: none;\r\n        }\r\n\r\n        &:hover {\r\n          background: #f9fafb;\r\n\r\n          &::before {\r\n            opacity: 1;\r\n          }\r\n        }\r\n\r\n        &::before {\r\n          content: '';\r\n          position: absolute;\r\n          left: 0;\r\n          top: 0;\r\n          bottom: 0;\r\n          width: 3px;\r\n          background: #6b7280;\r\n          opacity: 0;\r\n          transition: opacity 0.2s ease;\r\n        }\r\n\r\n        .card-emoji {\r\n          width: 40px;\r\n          height: 40px;\r\n          border-radius: 8px;\r\n          display: flex;\r\n          align-items: center;\r\n          justify-content: center;\r\n          margin-right: 1rem;\r\n          flex-shrink: 0;\r\n          font-size: 1.25rem;\r\n          position: relative;\r\n\r\n          .court-type-badge {\r\n            position: absolute;\r\n            top: -4px;\r\n            right: -4px;\r\n            font-size: 9px;\r\n            font-weight: bold;\r\n            padding: 2px 5px;\r\n            border-radius: 10px;\r\n            line-height: 1;\r\n            z-index: 2;\r\n            border: 1px solid rgba(255, 255, 255, 0.8);\r\n            \r\n            &.high-court {\r\n              background: linear-gradient(135deg, #1e40af, #3b82f6);\r\n              color: #ffffff;\r\n              box-shadow: 0 2px 4px rgba(30, 64, 175, 0.3);\r\n            }\r\n            \r\n            &.district-court {\r\n              background: linear-gradient(135deg, #7c3aed, #a855f7);\r\n              color: #ffffff;\r\n              box-shadow: 0 2px 4px rgba(124, 58, 237, 0.3);\r\n            }\r\n\r\n            &.supreme-court {\r\n              background: linear-gradient(135deg, #b45309, #f59e0b);\r\n              color: #ffffff;\r\n              box-shadow: 0 2px 4px rgba(180, 83, 9, 0.3);\r\n            }\r\n          }\r\n        }\r\n\r\n        .card-details {\r\n          flex-grow: 1;\r\n          min-width: 0;\r\n\r\n          .card-title {\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: space-between;\r\n            font-weight: 900;\r\n            color: #6b7280;\r\n            font-size: 0.8rem;\r\n            margin-bottom: 8px;\r\n\r\n            .courtref-displayboard {\r\n              font-size: 12px;\r\n            }\r\n\r\n            .status-chip {\r\n              margin-left: auto;\r\n              font-size: 0.7rem;\r\n              padding: 0.25rem 0.5rem;\r\n              border-radius: 8px;\r\n              font-weight: 600;\r\n              display: flex;\r\n              gap: 4px;\r\n              align-items: center;\r\n\r\n              &.completed {\r\n                background: #d1fae5;\r\n                color: #065f46;\r\n              }\r\n\r\n              &.pending {\r\n                background: #fee2e2;\r\n                color: #991b1b;\r\n              }\r\n            }\r\n\r\n            .hearing-parties {\r\n              font-size: 0.8rem;\r\n              color: #6b7280;\r\n              font-weight: 900;\r\n              margin-left: 6px;\r\n              white-space: nowrap;\r\n              text-overflow: ellipsis;\r\n            }\r\n          }\r\n\r\n          .card-sub {\r\n            display: flex;\r\n            align-items: flex-start;\r\n            gap: 6px;\r\n            font-size: 0.8rem;\r\n            color: #6b7280;\r\n            font-weight: 500;\r\n            white-space: normal;\r\n            overflow-wrap: break-word;\r\n            word-break: break-word;\r\n            overflow: hidden;\r\n\r\n            .icon-image {\r\n              flex-shrink: 0;\r\n              margin-top: 2px;\r\n            }\r\n\r\n            &::before {\r\n              flex-shrink: 0;\r\n            }\r\n          }\r\n        }\r\n\r\n        &.upcoming-task-card {\r\n          .card-emoji {\r\n            background: #f3f4f6;\r\n            color: #6b7280;\r\n\r\n            &::before {\r\n              content: '';\r\n              display: inline-block;\r\n              width: 22px;\r\n              height: 22px;\r\n              background-image: url('../../assets/images/taskhead-icon.png');\r\n              background-size: contain;\r\n              background-repeat: no-repeat;\r\n            }\r\n          }\r\n        }\r\n\r\n        &.hearing-card {\r\n          .card-emoji {\r\n            background: #f3f4f6;\r\n            color: #6b7280;\r\n\r\n            &::before {\r\n              content: '';\r\n              display: inline-block;\r\n              width: 22px;\r\n              height: 22px;\r\n              background-image: url('../../assets/images/bar-icon.png');\r\n              background-size: contain;\r\n              background-repeat: no-repeat;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .no-data {\r\n      text-align: center;\r\n      color: #6b7280;\r\n      padding: 3rem 2rem;\r\n      font-size: 0.95rem;\r\n      background: #f9fafb;\r\n      border: 2px dashed #d1d5db;\r\n      border-radius: 8px;\r\n      margin-top: 1rem;\r\n    }\r\n\r\n    .show-more-toggle-container {\r\n      position: absolute;\r\n      bottom: 0;\r\n      left: 0;\r\n      right: 0;\r\n      display: flex;\r\n      justify-content: center;\r\n      align-items: center;\r\n      background: linear-gradient(to top, rgba(255, 255, 255, 0.95) 60%, transparent);\r\n      cursor: pointer;\r\n      z-index: 10;\r\n      gap: 0.5rem;\r\n\r\n      .toggle-text {\r\n        font-size: 0.875rem;\r\n        color: #374151;\r\n        font-weight: 500;\r\n      }\r\n\r\n      .toggle-circle {\r\n        width: 32px;\r\n        height: 32px;\r\n        background: #374151;\r\n        border-radius: 50%;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        transition: all 0.2s ease;\r\n        border: 2px solid #ffffff;\r\n\r\n        .arrow-icon {\r\n          color: #ffffff;\r\n          font-size: 1rem;\r\n          transition: transform 0.3s ease;\r\n        }\r\n      }\r\n\r\n      &:hover {\r\n        .toggle-circle {\r\n          background: #4b5563;\r\n        }\r\n\r\n        .toggle-text {\r\n          color: #111827;\r\n        }\r\n      }\r\n\r\n      &.expanded .arrow-icon {\r\n        transform: rotate(180deg);\r\n      }\r\n    }\r\n  }\r\n\r\n  // Responsive design\r\n  @media (max-width: 1200px) {\r\n    .tabs-container {\r\n      flex-wrap: wrap;\r\n      gap: 0.5rem;\r\n      \r\n      .tabs {\r\n        width: 100%;\r\n      }\r\n      \r\n      .hearing-sub-tabs {\r\n        width: 100%;\r\n      }\r\n    }\r\n  }\r\n\r\n  @media (max-width: 768px) {\r\n    padding: 1.5rem;\r\n\r\n    .tabs-container {\r\n      flex-direction: column;\r\n      align-items: stretch;\r\n      gap: 0.75rem;\r\n      margin-bottom: 1rem;\r\n    }\r\n\r\n    .tabs {\r\n      width: 100%;\r\n      \r\n      button {\r\n        font-size: 0.9rem;\r\n        padding: 0.65rem 1rem;\r\n      }\r\n    }\r\n\r\n    .hearing-sub-tabs {\r\n      width: 100%;\r\n      overflow-x: auto;\r\n      \r\n      &::-webkit-scrollbar {\r\n        height: 4px;\r\n      }\r\n      \r\n      &::-webkit-scrollbar-track {\r\n        background: transparent;\r\n      }\r\n      \r\n      &::-webkit-scrollbar-thumb {\r\n        background: #cbd5e1;\r\n        border-radius: 2px;\r\n      }\r\n      \r\n      button {\r\n        font-size: 0.75rem;\r\n        padding: 0.4rem 0.6rem;\r\n        gap: 0.25rem;\r\n\r\n        .tab-count {\r\n          font-size: 0.65rem;\r\n          padding: 0.1rem 0.25rem;\r\n          min-width: 14px;\r\n        }\r\n      }\r\n    }\r\n\r\n    .items-grid .upcoming-item-card {\r\n      padding: 0.875rem 1rem;\r\n\r\n      .card-emoji {\r\n        width: 36px;\r\n        height: 36px;\r\n        margin-right: 0.875rem;\r\n        font-size: 1.1rem;\r\n\r\n        .court-type-badge {\r\n          font-size: 8px;\r\n          padding: 1px 4px;\r\n          top: -3px;\r\n          right: -3px;\r\n        }\r\n      }\r\n\r\n      .card-details {\r\n        .card-title {\r\n          font-size: 0.9rem;\r\n        }\r\n\r\n        .card-sub {\r\n          font-size: 0.75rem;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.ref-with-tooltip {\r\n  position: relative;\r\n  cursor: pointer;\r\n\r\n  .custom-tooltip {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 17%;\r\n    transform: translateY(-50%) translateX(8px);\r\n    background: #f5faff;\r\n    color: #1e293b;\r\n    border: 1px solid #dbeafe;\r\n    box-shadow: 0 4px 16px rgba(147, 197, 253, 0.25);\r\n    padding: 0.5rem 0.75rem;\r\n    border-radius: 8px;\r\n    font-size: 0.75rem;\r\n    white-space: normal;\r\n    max-width: 300px;\r\n    z-index: 9999;\r\n    opacity: 0;\r\n    transition: opacity 0.3s ease, transform 0.3s ease;\r\n    pointer-events: none;\r\n  }\r\n\r\n  &:hover .custom-tooltip {\r\n    opacity: 1;\r\n    transform: translateY(-50%) translateX(0);\r\n    pointer-events: auto;\r\n  }\r\n}\r\n\r\n.custom-tooltip {\r\n  position: absolute;\r\n  transform: translateX(-50%) translateY(-30%);\r\n  background-color: #333;\r\n  color: #fff;\r\n  padding: 8px 12px;\r\n  border-radius: 6px;\r\n  font-size: 13px;\r\n  max-width: 400px;\r\n  word-wrap: break-word;\r\n  z-index: 1000;\r\n  pointer-events: none;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\r\n  line-height: 1.4;\r\n  top: 250px;\r\n  left: 200px;\r\n\r\n  &::after {\r\n    content: '';\r\n    position: absolute;\r\n    bottom: 100%;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    width: 0;\r\n    height: 0;\r\n    border-left: 6px solid transparent;\r\n    border-right: 6px solid transparent;\r\n    border-bottom: 6px solid #333;\r\n  }\r\n}\r\n\r\n// Custom next hearing date styling\r\n.custom-next-date {\r\n  color: #059669 !important;\r\n  font-weight: 500 !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
